import React, { useEffect, useState, useRef } from 'react';
import axios from "axios";
import base64 from "base-64"
import { Container, Button, ButtonGroup } from "reactstrap";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Navbar from './Navbar'
import Footer from './Footer'
import { FaCalendarAlt, FaCaretDown } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assests/css/generatereport.css'
import { BiChevronsLeft, BiChevronsRight} from 'react-icons/bi';
//datepicker
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
//monthpicker\
import 'react-month-picker/css/month-picker.css';
import IdleMonitor from './userAutoLogout';  //session management
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import ENV from '../env';

const MonthlyGenerateReport = () => {
    const history = useHistory();
    const [startDate, setStartDate] = useState(localStorage.getItem('start-date')?localStorage.getItem('start-date'):moment().startOf('month').subtract(1, 'months').format('MM/DD/YYYY'))
    const [endDate, setEndDate] = useState(localStorage.getItem('end-date')?localStorage.getItem('end-date'):moment().endOf("day").format('MM/DD/YYYY'))
    const [customView, setCustomView] = useState(true)
    const [loading, setLoading] = useState(false)
    const [manageHeight, setManageHeight] = useState("94.5vh")
    const defaultBtnStyle = "secondary";
    const [monthText, setMonthText] = useState([new Date()]);

    useEffect(() => {}, []);


    //on selecting date range from datepicker
    const handleDateRange = (event, dates) => {
        setStartDate(moment(dates.startDate).format('MM/DD/YYYY'));
        setEndDate(moment(dates.endDate).format('MM/DD/YYYY'));
        localStorage.setItem('start-date',moment(dates.startDate).format('MM/DD/YYYY'))
        localStorage.setItem('end-date',moment(dates.endDate).format('MM/DD/YYYY'))
    }

    //generate report api
    const generateReportApi = (start, end) => {
        Promise.all([
            localStorage.getItem('userId'),
            localStorage.getItem('sToken')
        ]).then(async (res) => {
            let userId = JSON.parse(res[0]);
            let sToken = JSON.parse(res[1]);
            let header = base64.encode(`${userId}:${sToken}`);
            let security = `Basic ${header}`;

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Security': security,
                    'Content-Type': 'application/json',
                }
            };

            let generateReportUrl = `${ENV.LOCUSB_API}/UserReport/${userId}/${start}/${end}`
            axios.get(generateReportUrl, options)
                .then(response => {
                    if (response.data.success === "true") {
                        // console.log("Report has been sent to mail", response.data)
                        toast.success("Report has been sent to mail!!")
                    }
                    else {
                        if (response.data.errorMsg === "Invalid_SecureToken") {
                            toast.error("Session expired, Please login again")
                            history.push('/')
                        }
                        else console.log("something went wrong in generateReport activity API", response.data.errorMsg)
                    }
                    setLoading(false);
                }).catch(err => {
                    console.log("error from generateReport activity api", err)
                })

        }).catch((err) => {
            console.log("generateReport api catch err", err)
        })
    }

    return (
        <div className="reportmaindiv" style={{ fontFamily: "Poppins", position: "relative" }}>
            <div style={{ width: "100%", height:"97.5vh"  }}>
                <Navbar />
                <Container style={{ alignItems: "center", justifyContent: "center", paddingTop: "4rem", height: /*"94.5vh"*/manageHeight }}>
                    <p className='gen-heading'>Generate Reports</p>

                    <div className="text-center bg-white reportmiddleDiv mx-auto">
                        {/* Options buttongroup */}
                        <div style={{ paddingBottom: "1rem" }}>
                            <ButtonGroup size="sm">
                                <Button className="ReportLeftBtnStyle ReportActiveBtnStyle" outline color={defaultBtnStyle} onClick={() => { setCustomView(false) }} active={!customView}>Custom</Button>
                                <   Button className="ReportRightBtnStyle ReportActiveBtnStyle" outline color={defaultBtnStyle} onClick={() => { setCustomView(true) }} active={customView}>Month</Button>
                            </ButtonGroup>

                        </div>
                        <div className="mainBox" style={{height: customView ? "min-content" : "139px"}}>
                            {/* Date range picker */}
                            <div style={{ display: !customView ? "block" : "none" }}>
                                <DateRangePicker
                                    autoUpdateInput={false}
                                    initialSettings={{
                                        orientation: "auto",
                                        startDate: moment(startDate, "MM/DD/YYYY"),
                                        endDate: moment(endDate, "MM/DD/YYYY"),
                                        maxDate: moment(),
                                        opens: 'center',
                                        ranges: {
                                            'Today': [moment(), moment()],
                                            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                            'Current Week': [moment().startOf('week'), moment()],
                                            'Last Week': [moment().subtract(1, 'weeks'), moment()],
                                            'Last 2 Weeks': [moment().subtract(2, 'weeks'), moment()],
                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                        },
                                        "alwaysShowCalendars": true,
                                        "shouldCloseOnSelect": false
                                    }}

                                    locale={{
                                        'format': 'DD/MM/YYYY'
                                    }}
                                    autoApply={true}
                                    onApply={(startDate, endDate) => handleDateRange(startDate, endDate)}
                                    onShow={() => { setManageHeight("105vh"); }}
                                    onHide={() => { setManageHeight("94.5vh"); }}
                                >
                                    <button className="displayBtn">
                                          <span style={{ marginLeft: "5px", marginBottom: "4px" }}><FaCalendarAlt margin="3px" fontSize="medium" /></span>
                                        <span className="displaySpan">{startDate} - {endDate}</span>
                                        <FaCaretDown />
                                    </button>
                                </DateRangePicker>
                            </div>
                            {/* Month picker */}
                            <div style={{ display: customView ? "block" : "none" }}>
                                <div className='calendar-container'>
                                    <Calendar
                                        onChange={(e)=> {setMonthText(e); console.log("month changed", e);}}
                                        value={monthText}
                                        maxDate={new Date()} // will not allow date later than today
                                        minDate={new Date(2010, 12, 1)} // will not allow date before 1st July 2015
                                        selectRange={false}
                                         maxDetail='year'
                                        prevLabel={<BiChevronsLeft/>}
                                        nextLabel={<BiChevronsRight/>}
                                        prev2Label={null}
                                        next2Label={null}
                                    />
                                </div>
                            </div>
                        </div>
                        <ToastContainer />
                        <div className="report-btn-margin">
                            <button type="submit" className="reportBtnDesg" onClick={() => {
                                setLoading(true);
                                // console.log("customView onclick", customView)
                                if (!customView) {
                                    // console.log("custom range submit:", moment(startDate, "YYYYMMDD"),moment(endDate, "YYYYMMDD"))
                                    // console.log("custom range submit:", moment(startDate).format("YYYYMMDD"), moment(endDate).format("YYYYMMDD"))
                                    generateReportApi(moment(startDate).format("YYYYMMDD"), moment(endDate).format("YYYYMMDD"));
                                } else {
                                    // console.log("submitted month", monthText)
                                    // console.log("submitted month start and end date", moment(monthText).startOf('month').format("YYYYMMDD"), moment(monthText).endOf('month').format("YYYYMMDD"))
                                    generateReportApi(moment(monthText).startOf('month').format("YYYYMMDD"), moment(monthText).endOf('month').format("YYYYMMDD"));
                                }
                            }} /*onClick={onHandleSubmit1(customView ? "range" : "month")}*/>
                                {(loading) ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Send"}
                            </button>
                        </div>
                    </div>

                </Container>
                <IdleMonitor/>
                <Footer />
            </div>
        </div>
    );
}

export default MonthlyGenerateReport;